import { useCallback, useEffect } from 'react'

import {
  EventData,
  TrackEventOptions,
  useEventTracking,
} from '@web-app/context/EventTrackingContext'
import { ANALYTICS_EVENTS } from '@web-app/lib/analyticsEvents'

export type AuthScreen = keyof typeof ANALYTICS_EVENTS.auth.screens
export type AuthTap = keyof typeof ANALYTICS_EVENTS.auth.taps
export type AuthMilestone = keyof typeof ANALYTICS_EVENTS.auth.milestones

// Fires once per mount of the calling screen.
export function useAuthScreenView(screen: AuthScreen) {
  const { trackEvent } = useEventTracking()
  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.auth.screens[screen])
  }, [trackEvent, screen])
}

export function useAuthAnalytics() {
  const { trackEvent } = useEventTracking()

  const trackTap = useCallback(
    (tap: AuthTap) => {
      trackEvent(ANALYTICS_EVENTS.auth.taps[tap])
    },
    [trackEvent],
  )

  const trackMilestone = useCallback(
    (
      milestone: AuthMilestone,
      data?: EventData,
      options?: TrackEventOptions,
    ) => {
      trackEvent(ANALYTICS_EVENTS.auth.milestones[milestone], data, options)
    },
    [trackEvent],
  )

  return { trackTap, trackMilestone }
}
